import Calendar from "date-bengali-revised";

const englishMonths = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const banglaMonths = [
  "জানুয়ারি",
  "ফেব্রুয়ারি",
  "মার্চ",
  "এপ্রিল",
  "মে",
  "জুন",
  "জুলাই",
  "আগস্ট",
  "সেপ্টেম্বর",
  "অক্টোবর",
  "নভেম্বর",
  "ডিসেম্বর",
];

const banglaCanlenderMonths = (value) => {
  const months = {
    1: "বৈশাখ",
    2: "জ্যৈষ্ঠ",
    3: "আষাঢ়",
    4: "শ্রাবণ",
    5: "ভাদ্র",
    6: "আশ্বিন",
    7: "কার্তিক",
    8: "অগ্রহায়ণ",
    9: "পৌষ",
    10: "মাঘ",
    11: "ফাল্গুন",
    12: "চৈত্র",
  };
  let str = "";

  return (
    value
      .toString()
      .split("")
      .forEach((num) => (str += months[num])),
    str
  );
};

const toBanglaNum = (value) => {
  const numbersObj = {
    0: "০",
    1: "১",
    2: "২",
    3: "৩",
    4: "৪",
    5: "৫",
    6: "৬",
    7: "৭",
    8: "৮",
    9: "৯",
    ".": ".",
    "-": "-",
  };

  if (isNaN(parseFloat(value)) || isNaN(value - 0)) {
    return "Invalid input type";
  }

  let str = "";

  return (
    value
      .toString()
      .split("")
      .forEach((num) => (str += numbersObj[num])),
    str
  );
};

export const getDate = (lang) => {
  const date = new Date();

  const month = date.getUTCMonth() + 1; // months from 1-12
  const day = date.getUTCDate();
  const year = date.getUTCFullYear();

  if (lang === "bn") {
    const cal = new Calendar();
    cal.fromGregorian(year, month, day);

    return `${toBanglaNum(date.getDate())} ${banglaMonths[date.getMonth()]} ${toBanglaNum(
      date.getFullYear()
    )}, ${toBanglaNum(cal.day)} ${banglaCanlenderMonths(cal.month)} ${toBanglaNum(cal.year)}`;
  } else {
    return `${englishMonths[date.getMonth()]} ${date.getDate()} ${date.getFullYear()}`;
  }
};
